import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import withStyles from '@mui/styles/withStyles';

const styles = theme => ({
  formControl: {
    width: '100%',
    paddingBottom: 20,
  },
});

const SingleChoice = ({classes, handler, question, value}) => (
  <Grid item xs={12}>
    <FormControl className={classes.formControl}>
      <FormLabel component="legend">{question.text}</FormLabel>
      <RadioGroup
        aria-label="gender"
        name="gender2"
        value={value}
        onChange={handler}>
        {question.answerOptions.map(answerOption => (
          <FormControlLabel
            key={answerOption.id}
            value={answerOption.id}
            control={<Radio color="secondary" />}
            label={answerOption.text}
          />
        ))}
      </RadioGroup>
    </FormControl>
  </Grid>
);

export default withStyles(styles)(SingleChoice);
